import { companyWorkspaceRoute } from '@/abilities/companyWorkspace/routes';
import { toCompanyWorkspaceDestination } from '@/abilities/companyWorkspace/vocabulary';
import { createDestinationRoute } from '@/router/destinationRoute';
import { companyWorkspaceDestinationRoutes } from '@/pages/company/WorkspaceRoute/destinationRoutes';

export const companyWorkspaceDestinationRoute = createDestinationRoute(
  companyWorkspaceDestinationRoutes,
  toCompanyWorkspaceDestination,
  companyWorkspaceRoute,
);
